<template>
  <div class="firewall-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="firewall" /> Firewall
        <!-- <el-button type="primary" @click="$router.push('/firewall')"><svg-icon icon-class="firewall" /> Firewall</el-button> -->
        <!-- <el-button type="info" @click="$router.push('/rules')"><svg-icon icon-class="rule" /> Rules</el-button>
        <el-button type="info" @click="$router.push('/blacklist')"><svg-icon icon-class="blacklist" /> Blacklist</el-button> -->

      </div>

      <div>
        <el-form ref="formSearch" :model="formSearch">
          <el-row :gutter="20">
              <el-col :span="3"
              ><div class="">
                <el-form-item label="CaseID">
                  <el-input
                    placeholder="CaseID"
                    v-model="formSearch.caseId"
                  ></el-input>
                </el-form-item></div
            ></el-col>
            <el-col :span="3">
              <div class="">
                <el-form-item label="BankholderId">
                  <el-input
                    placeholder="BankholderId"
                    v-model="formSearch.bankholderId"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="Member Code">
                  <el-input
                    placeholder="Member Code"
                    v-model="formSearch.membercode"
                  ></el-input
                ></el-form-item></div
            ></el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="Start Date">
                  <el-date-picker
                    v-model="formSearch.startDate"
                    type="date"
                    placeholder="Start Date"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker
                ></el-form-item></div
            ></el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="End Date">
                  <el-date-picker
                    v-model="formSearch.endDate"
                    type="date"
                    placeholder="End Date"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker
                ></el-form-item></div
            ></el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="Payment Type">
                  <el-select
                    v-model="formSearch.paymentType"
                    placeholder="Payment Type"
                    style="width: 100%"
                  >
                    <el-option label="All" value=""> </el-option>
                    <el-option label="Payin" value="payin"> </el-option>
                    <el-option label="Payout" value="payout">
                    </el-option> </el-select
                ></el-form-item></div
            ></el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="Status">
                  <el-select
                    v-model="formSearch.status"
                    placeholder="Status"
                    style="width: 100%"
                  >
                    <el-option label="All" value=""> </el-option>
                    <el-option label="Wait" value="wait"> </el-option>
                    <el-option label="OK" value="OK"> </el-option>
                    <el-option label="Decline" value="decline"> </el-option>
                    <el-option label="Approve" value="approve">
                    </el-option> </el-select
                ></el-form-item></div
            ></el-col>
            <el-col :span="3"
              ><div class="">
                <el-form-item label="Hit Firewall">
                  <el-select
                    v-model="formSearch.onlyhitfirewall"
                    style="width: 100%"
                  >
                    <el-option label="All" :value="null"> </el-option>
                    <el-option label="Yes" :value="true"> </el-option>
                    <el-option label="No" :value="false"> </el-option>
                     </el-select
                >
                  </el-form-item></div
            ></el-col>
          </el-row>
        </el-form>
        <div class="text-left">
          <el-button type="primary" @click="search" icon="el-icon-search" :loading="loading">
            Search
          </el-button>
          <el-button type="danger" @click="reset" icon="el-icon-refresh">
            Reset
          </el-button>
          <el-button style="float:right" type="success" @click="exportReport" icon="el-icon-download">
            Export
          </el-button>
        </div>
      </div>

      <div style="margin-top:20px">
        <data-tables
          :data="dataTable"
          border
          style="width: 100%"
          size="mini"
          :page-size="10"
          :pagination-props="{
            background: true,
            pageSizes: [10, 20, 50, 100, 200],
          }"
          v-loading="loading"
        >
          <el-table-column
            prop="caseId"
            label="CaseID"
            width="120"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="createdDate"
            label="Created"
            width="120"
            align="center"
          >
          <template slot-scope="scope">
           {{ dateFormat(scope.row.createdDate) }}
          </template>
          </el-table-column>

          <el-table-column
            prop="bankholderId"
            label="BankholderId"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="memberCode"
            label="Member Code"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="hitReason"
            label="Reason"
            min-width="320"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="amount"
            label="Amount"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="currency"
            label="Currency"
            width="90"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="paymentType"
            label="Payment Type"
            width="110"
            align="center"
          >
          <template slot-scope="scope">        
            <el-tag v-if="scope.row.paymentType == 'payout'" type="warning">{{scope.row.paymentType}}</el-tag>    
            <el-tag v-if="scope.row.paymentType == 'payin'">{{scope.row.paymentType}}</el-tag>
          </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            width="100"
            align="center"
          >
          <template slot-scope="scope">        
            <el-tag v-if="scope.row.status == 'wait'" type="info">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.status == 'decline'" type="danger">{{scope.row.status}}</el-tag>    
            <el-tag v-if="scope.row.status == 'approve'" type="success">{{scope.row.status}}</el-tag>
            <el-tag v-if="scope.row.status == 'OK'" >{{scope.row.status}}</el-tag>
          </template>
          </el-table-column>

          <el-table-column
            prop="updatedDate"
            label="Updated"
            width="120"
            align="center"
          >
          <template slot-scope="scope">
           {{ dateFormat(scope.row.updatedDate) }}
          </template>
          </el-table-column>
          <el-table-column
            prop="paymentuid"
            label="Actions"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showDetail(scope.row.paymentuid)"
              >
                Detail
              </el-button>
              <el-button
                type="danger"
                size="mini"
                @click="exportProfile(scope.row.paymentuid)"
              >
                Export
              </el-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
  </div>
</template>

<script>
import { dateFormat } from "@/utils";
import { transactionSearch, getTransactionExcel, reportFirewallProfile } from "@/api/firewall";
export default {
  data() {
    return {
      loading: false,
      dataTable: [],
      formSearch: {
        caseId: "",
        plusuid: "",
        membercode: "",
        startDate: "",
        endDate: "",
        bankholderId: "",
        status: "wait",
        onlyhitfirewall: true,
        paymentType: ""
      },
    };
  },
  methods: {
    search() {
      this.dataTable = [];
      this.loading = true;
      // this.formSearch.startDate = this.dateFormat(this.formSearch.startDate, "YYYY-MM-DD");
      // this.formSearch.endDate = this.dateFormat(this.formSearch.endDate, "YYYY-MM-DD");
      transactionSearch(this.formSearch).then(({result, data}) => {
        this.loading = false;
        if(result){
          this.dataTable = data;
        }
      });
  
    },
    reset() {
      this.formSearch.caseId = "";
      this.formSearch.bankholderId = "";
      this.formSearch.plusuid = "";
      this.formSearch.membercode = "";
      this.formSearch.startDate = "";
      this.formSearch.endDate = "";
      this.formSearch.status = "wait";
      this.formSearch.onlyhitfirewall = true;
    },

    showDetail(transactionid) {
    //  this.$router.push({
    //     name: "FirewallTransactionDetail",
    //     params: {
    //       transactionid: transactionid,
    //     },
    //   });
      window.open(`/firewall/transaction/detail/${transactionid}`, '_blank');
    },
    dateFormat(date, format = 'YYYY-MM-DD HH:mm') {
      return date ?  dateFormat(date, format) : "";
    },
    exportReport(){
            this.formSearch.startDate = this.dateFormat(this.formSearch.startDate, "YYYY-MM-DD");
      this.formSearch.endDate = this.dateFormat(this.formSearch.endDate, "YYYY-MM-DD");
      getTransactionExcel(this.formSearch)
    },
    exportProfile(transactionid){
      reportFirewallProfile(transactionid)
    }
  },
  mounted() {
    this.search();
  },
};
</script>

<style lang="scss">
.firewall-container {
  .el-tag{
    text-transform: capitalize;
  }
}
</style>